export default (state = false, action) =>
  action.type === "PAYMENT_MODAL" ? action.payload : state
